/* Forged Racing — Shipping Protection (opt-in, 5% of cart subtotal).
   Fee = 5% of the cart subtotal (protection line excluded), rounded UP to
   the next $0.50, minimum $0.50, capped at $100.00. Each 50-cent step is a
   variant of the protection product (handle from the widget's data attribute).
   Covers lost-in-transit and damaged-in-transit only (terms: /pages/shipping-protection).
   Not offered on sticker-only carts: products tagged frg-untracked-mail can
   ship by untracked First Class, so a lost claim can't be verified.
   The protection line is hidden from the drawer's item list (it has its own
   widget + totals row), so customers can't change its quantity.
   Deliberately avoids the word "insurance" anywhere in UI copy.
   Off by default: state is read from the cart, never assumed or pre-set. */
(function () {
  'use strict';

  var RATE = 0.05;      /* 5% */
  var STEP = 50;        /* round up to 50 cents */
  var MIN_FEE = 50;     /* $0.50 */
  var MAX_FEE = 10000;  /* $100.00 cap (carts of $2,000+) */
  var UNTRACKED_TAG = 'frg-untracked-mail';

  var root = null;
  var handle = '';
  var variantsByFee = null;   /* fee(cents) → variant id */
  var lookupFailed = false;   /* protection product/handle confirmed missing this page load */
  var tagsByHandle = {};      /* product handle → tags array (cached per page load) */
  var busy = false;
  var lastSignature = '';

  function feeForSubtotal(cents) {
    if (!cents || cents <= 0) return 0;
    var fee = Math.ceil((cents * RATE) / STEP) * STEP;
    if (fee < MIN_FEE) fee = MIN_FEE;
    if (fee > MAX_FEE) fee = MAX_FEE;
    return fee;
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* Hide the protection product's own row in the drawer item list. */
  function hideProtectionLines() {
    if (!handle) return;
    var list = document.querySelector('[data-forged-cart-items]');
    if (!list) return;
    var links = list.querySelectorAll('a[href^="/products/' + handle + '"]');
    for (var i = 0; i < links.length; i++) {
      var li = links[i].closest('li');
      if (li && !li.hidden) li.hidden = true;
    }
  }

  /* Load the protection product once. Resolves to null if it doesn't exist —
     in that case the widget stays hidden rather than rendering broken.
     A confirmed-missing result is sticky for the rest of the page session. */
  function loadVariants() {
    if (variantsByFee) return Promise.resolve(variantsByFee);
    if (lookupFailed) return Promise.resolve(null);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) { lookupFailed = true; return null; }
        variantsByFee = {};
        p.variants.forEach(function (v) { variantsByFee[v.price] = v.id; });
        return variantsByFee;
      })
      .catch(function () { lookupFailed = true; return null; });
  }

  function tagsFor(h) {
    if (tagsByHandle[h]) return Promise.resolve(tagsByHandle[h]);
    return fetch('/products/' + h + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var tags = (p && p.tags) ? p.tags : [];
        tagsByHandle[h] = tags;
        return tags;
      })
      .catch(function () { return []; });
  }

  /* true when every non-protection item in the cart is an untracked-mail item */
  function isStickerOnly(cart) {
    var handles = [];
    cart.items.forEach(function (it) {
      if (it.handle !== handle && handles.indexOf(it.handle) === -1) handles.push(it.handle);
    });
    if (!handles.length) return Promise.resolve(false);
    return Promise.all(handles.map(tagsFor)).then(function (lists) {
      return lists.every(function (tags) { return tags.indexOf(UNTRACKED_TAG) !== -1; });
    });
  }

  function protectionLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === handle) {
        return { item: cart.items[i], line: i + 1 };
      }
    }
    return null;
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function addVariant(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) { return r.json(); });
  }

  function refreshDrawer() {
    if (window.ForgedCart && window.ForgedCart.refresh) return window.ForgedCart.refresh();
    return Promise.resolve();
  }

  function removeProtection(existing) {
    busy = true;
    return changeLine(existing.line, 0)
      .then(function () { busy = false; lastSignature = ''; return refreshDrawer(); })
      .catch(function () { busy = false; });
  }

  /* Render widget + totals row from the current cart. Also re-prices the
     protection line if the subtotal changed while protection is on, and
     removes it if it is alone in the cart or the cart is sticker-only. */
  function sync() {
    hideProtectionLines();
    if (!root || busy) return;
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return loadVariants().then(function (map) {
          if (!map) { root.hidden = true; return; }

          var existing = protectionLine(cart);
          var otherItems = cart.item_count - (existing ? existing.item.quantity : 0);

          /* protection left alone in the cart → take it out */
          if (existing && otherItems <= 0) return removeProtection(existing);

          return isStickerOnly(cart).then(function (stickerOnly) {
            if (stickerOnly) {
              root.hidden = true;
              var r0 = document.querySelector('[data-frg-protection-row]');
              if (r0) r0.hidden = true;
              if (existing) return removeProtection(existing);
              return;
            }

            /* base subtotal EXCLUDES protection, so it can't inflate its own fee */
            var base = cart.items_subtotal_price - (existing ? existing.item.final_line_price : 0);
            var fee = feeForSubtotal(base);
            var wantId = map[fee];

            if (!wantId) { root.hidden = true; return; }   /* no variant at this price */
            root.hidden = otherItems <= 0;

            var feeEl = root.querySelector('[data-frg-protection-fee]');
            var btn = root.querySelector('[data-frg-protection-toggle]');
            if (feeEl) feeEl.textContent = money(fee);

            var on = !!existing;
            root.classList.toggle('is-on', on);
            if (btn) {
              btn.textContent = on ? 'Remove' : 'Add';
              btn.setAttribute('aria-pressed', on ? 'true' : 'false');
            }

            /* totals breakdown row */
            var row = document.querySelector('[data-frg-protection-row]');
            if (row) {
              row.hidden = !on;
              var amt = row.querySelector('[data-frg-protection-row-amount]');
              if (amt && existing) amt.textContent = money(existing.item.final_line_price);
            }

            /* fee drifted (or quantity changed) while on → swap to the right variant, qty 1 */
            var sig = (on ? '1' : '0') + ':' + fee + ':' + (existing ? existing.item.variant_id + 'x' + existing.item.quantity : '');
            if (on && (existing.item.variant_id !== wantId || existing.item.quantity !== 1) && sig !== lastSignature) {
              lastSignature = sig;
              busy = true;
              return changeLine(existing.line, 0)
                .then(function () { return addVariant(wantId); })
                .then(function () { busy = false; return refreshDrawer(); })
                .catch(function () { busy = false; });
            }
            lastSignature = sig;
          });
        });
      })
      .catch(function () { /* leave widget as-is on network error */ });
  }

  function onToggle() {
    if (busy) return;
    busy = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existing = protectionLine(cart);
        if (existing) return changeLine(existing.line, 0);
        return isStickerOnly(cart).then(function (stickerOnly) {
          if (stickerOnly) return null;
          var base = cart.items_subtotal_price;
          return loadVariants().then(function (map) {
            var id = map && map[feeForSubtotal(base)];
            return id ? addVariant(id) : null;
          });
        });
      })
      .then(function () { busy = false; return refreshDrawer(); })
      .then(function () { lastSignature = ''; sync(); })
      .catch(function () { busy = false; });
  }

  function init() {
    root = document.querySelector('[data-frg-protection]');
    if (!root) return;
    handle = root.dataset.frgProtectionHandle;

    var btn = root.querySelector('[data-frg-protection-toggle]');
    if (btn) btn.addEventListener('click', onToggle);

    /* Re-sync whenever the drawer re-renders its line items. Decoupled from
       forged-cart.js (a verbatim donor port) so that file stays untouched. */
    var items = document.querySelector('[data-forged-cart-items]');
    if (items && window.MutationObserver) {
      new MutationObserver(function () { sync(); }).observe(items, { childList: true });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-forged-cart-trigger]')) setTimeout(sync, 350);
    });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
